module.exports = __webpack_public_path__ + "img/before1.2ba034b8.jpg";